import { Component, Input } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

@Component({
  selector: "app-ce-date-picker",
  templateUrl: "./ce-date-picker.component.html",
  styleUrls: ["./ce-date-picker.component.css"],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: CeDatePickerComponent,
    multi: true
  }]
})
export class CeDatePickerComponent implements ControlValueAccessor {
  public bsConfig: object;
  public value: Date = null;

  @Input() public isDisabled: boolean = false;
  @Input() public minDate?: Date = null;
  @Input() public maxDate?: Date = null;
  @Input() public placement?: string = "auto";

  private onChange = (value: Date) => {};
  private onTouched = () => {};

  public writeValue(obj: any): void {
    this.value = obj;
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  
  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  constructor() {
    this.bsConfig = Object.assign({}, {
      containerClass: "theme-dark-blue",
      showWeekNumbers: false
    });
  }

  public onValueChanged(date: Date): void {
    const normalizedDate = this.normalizeDate(date);

    if (this.value !== normalizedDate) {
      this.value = normalizedDate;
      this.onChange(normalizedDate);
      this.onTouched();
    }
  }

  private normalizeDate(date: Date): Date {
    if (!date) {
      return null;
    }
    
    date.setHours(0, 0, 0, 0);
    return date;
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/components/ce-date-picker/ce-date-picker.component.ts